// FONTE ÚNICA dos defaults conservadores de parâmetros de simulação,
// consumida por: apps/api (scenario-preview.resolve), apps/web (preview-engine/SimParamFields)
// e apps/worker (simulations.engine-params). O motor Python (apps/simulation/src/engine/des.py)
// ESPELHA estes valores com comentário apontando p/ cá (sem import cross-language) — o teste
// tests/test_des_queueing.py trava a igualdade. Mudou aqui ⇒ mudar lá.
// Valores = o set que o preview (API+web) já usava — mais realista que o antigo do worker
// (mtbf 100min ≈ 1,7h era agressivo) e não muda o baseline que os usuários já veem (research).

export const SIM_DEFAULTS = {
  feedRateUnH: 60,
  mtbfMin: 480, // 8 h
  mttrMin: 30,
  qualityTargetPct: 95,
} as const;

/** Ciclo é DERIVADO do ritmo canônico: 3600/feed ⇒ 60 s no default. */
export const DEFAULT_CYCLE_S = 3600 / SIM_DEFAULTS.feedRateUnH;
